import { forwardRef } from 'react';

import {
  InputRightElement,
  AssistanceApprovedIcon,
  AssistanceAvailableIcon,
  AssistanceRejectedIcon,
  type InputRightElementProps,
} from '@frontend/legacy-components';

import { useInputGroupWithSuggestionsContext } from './InputGroupWithSuggestionsContext';

export const InputGroupWithSuggestionsRightElement = forwardRef<
  HTMLDivElement,
  InputRightElementProps
>((props, ref) => {
  const { availableSuggestions, acceptedSuggestion, isDisabled } =
    useInputGroupWithSuggestionsContext();

  return (
    <InputRightElement
      ref={ref}
      h={4}
      overflow="hidden"
      pointerEvents="none"
      size="sm"
      zIndex="auto"
      {...props}
      {...(availableSuggestions && {
        w: 8,
      })}
    >
      {!isDisabled &&
        (availableSuggestions ? (
          <>
            <AssistanceAvailableIcon
              boxSize="1.375rem"
              color="alert.assistance"
              top="0.3125rem"
              right="0.3125rem"
              position="absolute"
            />
          </>
        ) : acceptedSuggestion ? (
          <AssistanceApprovedIcon
            boxSize="1.375rem"
            color="alert.assistance"
            top="0.3125rem"
            right="0.3125rem"
            position="absolute"
          />
        ) : (
          <>
            <AssistanceRejectedIcon
              boxSize="1.375rem"
              top="0.3125rem"
              right="0.3125rem"
              color="feature.placeholder"
              position="absolute"
            />
          </>
        ))}
    </InputRightElement>
  );
});
InputGroupWithSuggestionsRightElement.displayName =
  'InputGroupWithSuggestionsRightElement';
